import { makeStyles } from '@material-ui/core';
import { neutral } from 'shared/styles/colors';

export default makeStyles({
  turboClock: {
    borderRadius: '0.3125rem',
    border: `1px solid ${neutral[20]}`,
    padding: '0 0.75rem',
    widht: '3rem',
    maxWidht: '3rem',
  },
  turboClockLabel: {
    fontSize: '0.75rem',
    fontWeight: 600,
    lineHeight: '1.25rem',
  },
});
